import type { IFilter } from '@models/Filter'
import type { GebiedLabel } from '@models/GebiedLabel'
import type { SearchResults } from '@models/SearchResults'

import { apiClient } from '../../../gateways/api'
import type { ContractinstellingenSearchFilters } from '../types/ContractinstellingenSearch'

export { fetchLabels, initialState }

const fetchLabels = async (
  filters: Partial<ContractinstellingenSearchFilters>,
) => {
  const { data } = await apiClient<SearchResults<GebiedLabel>>({
    url: '/rest/label/search',
    method: 'POST',
    data: {
      filters: createFilters(filters),
      skip: 0,
      limit: 1000,
    },
  })

  return data
}

const initialState: { data: SearchResults<GebiedLabel> } = {
  data: { count: 0, skip: 0, limit: 25, items: [] },
}

const createFilters = ({
  verantwoordelijke,
}: Partial<ContractinstellingenSearchFilters>) => {
  const filters: IFilter[] = [
    { name: 'projectType', value: 'Hoofdleiding', operator: 'eq' },
  ]

  if (verantwoordelijke)
    filters.push({
      name: 'verantwoordelijke',
      value: verantwoordelijke.code,
      operator: 'eq',
    })

  return filters
}
